import { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface CardProps {
  className?: string;
  variant?: "full" | "centered";
}

/**
 *
 */
const CardRoot: FunctionComponent<PropsWithChildren<CardProps>> = ({
  className,
  variant = "centered",
  children,
}) => {
  const css = cn(
    "border border-gray-300 px-4 max-sm:rounded-none  sm:px-card w-full  p-card rounded-card flex flex-col gap-5 bg-card",
    variant === "centered" && "sm:w-fit mx-auto",
    variant === "full" && "w-full",
    className,
  );
  return <div className={css}>{children}</div>;
};

export interface CardHeaderProps {
  children: ReactNode;
  className?: string;
}

function CardHeader({ children, className }: CardHeaderProps) {
  return (
    <h2
      className={cn(
        "font-card-heading text-card-heading-color text-card-heading-size mb-1",
        className,
      )}
    >
      {children}
    </h2>
  );
}

export interface CardContentProps {
  children: ReactNode;
  className?: string;
}

function CardContent({ children, className }: CardContentProps) {
  return <div className={cn("h-full w-full", className)}>{children}</div>;
}

function CardSubHeader({ children }: CardHeaderProps) {
  return <p className="-mt-6 text-sm text-gray-600">{children}</p>;
}

export const Card = Object.assign(CardRoot, {
  Header: CardHeader,
  SubHeader: CardSubHeader,
  Content: CardContent,
});
